// Wspólna ramka ikon (ikony.tsx, ikony-dalsze.tsx): SVG 24×24, obrys w kolorze tekstu (stroke="currentColor"),
// zawsze aria-hidden - opis daje przycisk/etykieta. Klasa `iot-ikona` (rozmiar z CSS).
import type { ReactNode, SVGProps } from "react";

export interface IkonaProps extends Omit<SVGProps<SVGSVGElement>, "children"> {
  /** Obrót o 180° (np. kciuk w dół, strzałka wstecz) */
  obrocona?: boolean;
}

export type KomponentIkony = (props: IkonaProps) => ReactNode;

export function Svg({ obrocona, className, children, ...reszta }: IkonaProps & { children: ReactNode }) {
  const klasa = ["iot-ikona", obrocona ? "iot-ikona--obrot" : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={klasa}
      {...reszta}
    >
      {children}
    </svg>
  );
}
